module.exports = __webpack_public_path__ + "img/subs-sweets.d38bfbe0.png";